import React from 'react'
import styled, { keyframes } from 'styled-components'

import { dayjs } from '@hozana/dates'
import type { TDateTime } from '@hozana/dates/types'

import { Icon } from 'elements/media/Icon'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
    color: grey;
  }
  50% {
    transform: rotate(90deg) scale(1.5);
    color: orange;
  }
  100% {
    transform: rotate(180deg) scale(1);
    color: grey;
  }
`

const scale = keyframes`
  0% {
    transform: scale(1);
    color: grey;
  }
  50% {
    transform: scale(1.5);
    color: orange;
  }
  100% {
    transform: scale(1);
    color: grey;
  }
`

const RotatingIcon = styled(Icon)`
  animation: ${rotation} 0.7s ease-in-out forwards;
`

const ScalingText = styled(Text)`
  animation: 0.7s ease-in-out 0.2s ${scale} forwards;
`

const getHourglassIcon = (hoursLeft: number) => {
  if (hoursLeft > 46) {
    return ICON.HOURGLASS_START
  } else if (hoursLeft > 2 && hoursLeft <= 46) {
    return ICON.HOURGLASS_HALF
  } else {
    return ICON.HOURGLASS_END
  }
}

type TPublishedUntilProps = {
  date: TDateTime
  animate?: boolean
}

export const PublishedUntil: TFC<TPublishedUntilProps> = ({ date, animate }) => {
  const hoursLeft = Math.round((new Date(date).getTime() - new Date().getTime()) / 1000 / 60 / 60)

  const intentionTime = dayjs(date)
    .fromNow(true)
    .replace(/^(\d+)\s(\S).+/, '$1$2')

  return (
    <Text color="black50" fontSize="0.9em">
      {animate ? (
        <>
          <RotatingIcon name={ICON.HOURGLASS_END} m="0 2px 0 0" size="1.5em" />
          <ScalingText vAlign="bottom">{intentionTime}</ScalingText>
        </>
      ) : (
        <>
          <Icon name={getHourglassIcon(hoursLeft)} m="0 2px 0 0" size="1.5em" />
          <Text vAlign="bottom">{intentionTime}</Text>
        </>
      )}
    </Text>
  )
}
